module.exports = __webpack_public_path__ + "static/media/up arrow.e10c1b06.svg";